var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbs,"breadcrumbsClass":"breadcrumbs","hideBack":true}})],1),(_vm.tripPoint && _vm.trip)?_c('v-flex',{attrs:{"xs12":""}},[_c('TripPointInfo',{attrs:{"trip-point":_vm.tripPoint,"trip":_vm.trip}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }